import { store } from '../_helpers/store'

export function authHeader() {
  const authToken = store.getState().authentication.token

  if (!authToken) {
    return {};
  }

  return { 'Authorization': `Bearer ${authToken}` };
}

export function axsToken() {
  const authToken = store.getState().authentication.token

  if (!authToken) {
    return {};
  }

  return { 'axs-token': authToken };
}